<ng-container *ngIf="notesToDisplay?.length > 0">
  <p class="table-title">ריכוז הערות וליקויים בפרויקט</p>
  <table class="data-table">
    <thead>
      <tr>
        <th>להלן פירוט הערות, ההערות המלאות בגוף הדו"ח ועליהן יש להסתמך</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let note of notesToDisplay">
        <td>
          <span>{{ note }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
</ng-container>
